import { useState, useEffect } from "react";

const Gallery = () => {
	const [listOfImages, setListOfImages] = useState([]);
	const [randomImages, setRandomImages] = useState([]);

	const importAll = (r) => r.keys().map(r);
	const NoOfImges = 7

	useEffect(() => {
		setListOfImages(importAll(require.context('../assets/gallery/', false, /\.(png|jpe?g|svg)$/)));
	}, []);

	useEffect(() => {
		// Create a list of 7 random images to display 
		for (let i = listOfImages.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[listOfImages[i], listOfImages[j]] = [listOfImages[j], listOfImages[i]];
		}

		setRandomImages(listOfImages.slice(0, NoOfImges));
	}, [listOfImages]);

	return (
		<div className="h-72 w-screen overflow-hidden">
			<div className="flex gap-8 animate object-cover">
			{randomImages.map((image, index) => (
				<img className="h-64 lg:h-72" key={index} src={image} alt="info" />
			))}
			</div>
		</div>
	);
}

export default Gallery;
